import React, { useState, useEffect, useCallback } from "react";
import Pagination from "@material-ui/lab/Pagination";
import PaginationItem from "@material-ui/lab/PaginationItem";

import { useLocation, useParams } from "react-router-dom";
import { Button, Breadcrumbs, Link } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import AssignmentService from "../../../../../../services/AssignmentService";
import { Link as LinkRouter} from "react-router-dom";
import AssignmentItem from "./components/AssignmentItem";
import { calcOffset, calcCountPages } from "../../../../../../utils/pagination";
import ScreenHeader from "../../../../components/ScreenHeader";
import EmptyResult from "../../../../../components/EmptyResult";
import AddAssignment from "./modals/modalNewAssignment";
import LessonsService from "../../../../../../services/LessonsService";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function AssignmentsScreen(props) {
  const assignmentsLoading = Array.from(Array(5).keys());
  const [lesson, setLesson] = useState({});
  const [assignments, setAssignments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { courseId, lessonId } = useParams()
  const [openModalAddNewAssignment, setOpenModalAddNewAssignment] = useState(false);

  // pagination
  const location = useLocation();
  let query = useQuery();
  const [countPages, setCountPages] = useState(0);
  const page = parseInt(query.get("page")) || 1;
  const paginationLimit = 5;

  const fetchLessonData = useCallback(async () => {
    setIsLoading(true);
    try{
      const result = await LessonsService.retrieveLesson(courseId, lessonId, {
        fields: 'id,name,course.id,course.name',
        expand: 'course'
      });
      setLesson(result.data);      
      setIsLoading(false);
    }catch (error) {
      setLesson({});
      setIsLoading(false);
    }  
  }, [courseId, lessonId]) 

  const fetchAssignments = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await AssignmentService.listAssignments(courseId, lessonId, {
        fields: "id,name,description,start_date,end_date,course,modified_datetime,assignment_type",
        limit: paginationLimit,
        offset: calcOffset(page, paginationLimit)
      });
      setAssignments(result.data.results);
      setCountPages(calcCountPages(result, paginationLimit));
      setIsLoading(false);
    } catch (error) {
      setAssignments([]);
    }
  }, [courseId, lessonId, page]);

  const removeCourseFromList = courseId => {
    const NewCourses = assignments.filter((item, index) => item.id !== courseId);
    setAssignments(NewCourses);
  };

  const updateAssignmentsFromList = () => {
    fetchAssignments();
  };

  useEffect(() => {
    // Query Params changued
    fetchLessonData()
    fetchAssignments();
  }, [fetchAssignments, fetchLessonData, location.search]);

  const handleClickOpenModalAddNewAssignment = () => {
    setOpenModalAddNewAssignment(true);
  };
  const handleClickCloseModalAddNewAssignment = () => {
    setOpenModalAddNewAssignment(false);
  };

  return (
    <div
      id="course-screen"
      className={`${props.className} dashboard-container`}
    >
       {/* BreadCrum */}
       <Breadcrumbs aria-label="breadcrumb">
        <Link
          color="inherit"
          component={LinkRouter}
          to={`/dashboard/syllabus/`}>
          Syllabus
        </Link>
        <Link
          to={`/dashboard/syllabus/`}
          color="inherit"
          component={LinkRouter}
          aria-current="page">
          {lesson.name || "..."}
        </Link>
        <Link
          to={location => location.pathname}
          color="textPrimary"
          component={LinkRouter}
          aria-current="page">
          {"Assignments"}
        </Link>
      </Breadcrumbs>
      
      {/* Header */}
      <ScreenHeader title="Assignments">
        <Button
          variant="outlined"
          color="primary"
          onClick={handleClickOpenModalAddNewAssignment}
          endIcon={<AddIcon />}
        >
          Add Assignment
        </Button>
      </ScreenHeader>

      {/* Body */}
      <div className="content">
        <div className="assignment-list" style={{ minHeight: "36em" }}>
          {isLoading ? (
            // Generate 5 courses of loading data
            assignmentsLoading.map(i => <AssignmentItem key={i} loading />)
          ) : // Show courses
          assignments.length > 0 ? (
            assignments.map(assignment => (
              <AssignmentItem
                data={assignment}
                courseId={courseId}
                lessonId={lessonId}
                key={assignment.id}
                removeItem={removeCourseFromList}
                updateAssignmentsFromList={updateAssignmentsFromList}
                openSnack={props.openSnack}
              />
            ))
          ) : (
            // Show Empty courses
            <EmptyResult />
          )}
        </div>
        <Pagination
          page={page}
          count={countPages}
          color="primary"
          size="large"
          renderItem={item => (
            <PaginationItem
              component={LinkRouter}
              to={ location =>
                `${location.pathname}${item.page === 1 ? "" : `?page=${item.page}`}`                
              }              
              {...item}
            />
          )}
        />
      </div>

      {/* Modal for add Assignment */}
      <AddAssignment
        open={openModalAddNewAssignment}
        courseId={courseId}
        lessonId={lessonId}
        onClose={handleClickCloseModalAddNewAssignment}
        updateAssignmentsFromList={updateAssignmentsFromList}
      />
    </div>
  );
}

export default AssignmentsScreen;
